<template>
  <div style="height: 100%; display: flex; flex-direction: column; overflow-x: hidden;">
    <!-- Bouton hamburger pour mobile -->
    <button :class="['sidebar-toggle', 'd-lg-none', { 'toggle-active': sidebarOpen }]" @click="toggleSidebar">
      <span v-if="!sidebarOpen">☰</span>
      <span v-else>✕</span>
    </button>

    <div class="row content" ref="wrapper" style="width: 100%; height: 100%;">
      <!-- Barre latérale avec classes responsive -->
      <div :class="['sidebar', 'col-2', 'd-flex', 'flex-column', 'align-items-start', { 'sidebar-open': sidebarOpen }]" style="background-color: #4dc9ff; padding: 10px;">
        <div class="sidebar-content">
          <p>
            <!-- {{ rows }} - {{ cols }} - {{ mosaicId }} -->
            <span v-if="progressStatus !== 'idle'"> — {{ progressPercent }}%</span>
          </p>
          
          <!-- Outils -->
          <div style="margin-bottom: 15px; padding: 0px 0px 0px 10px;">
            <p style="color: white;">Outil :</p>
            <div class="btn-group-vertical" role="group" aria-label="Vertical button group">
              <button
                v-for="tool in tools"
                :key="tool.value"
                :class="['tool-button btn btn-light', { active: currentTool == tool.value }]"
                @click="updateTool(tool)"
                type="button"
              >
                {{ tool.label }}
              </button>
            </div>
          </div>
          
          <!-- Pièces -->
          <div style="margin-bottom: 15px; padding: 0px 0px 0px 10px;">
            <p style="color: white;">Piece :</p>
            <div class="d-flex flex-wrap pieces-scroll" style="gap: 5px; max-height: 30vh; overflow-y: auto;">
              <button
                v-for="piece in listePiece"
                :key="piece['id']"
                :style="{
                  border: selectPiece === piece['id'] ? '2px solid #000' : '1px solid #ccc',
                  width: `${piece.shema.taileX[0] * 40}px`,
                  height: `${piece.shema.taileY[0] * 40}px`,
                  padding: '0px 0px 0px 0px',
                  margin: '0px 5px 0px 0px',
                  overflow: 'hidden',
                }"
                class="color-button"
                @click="selectPiece = piece['id']"
              >
                <img
                  :src="`/images/image_piece/${piece['id']}.svg`"
                  :alt="piece['id']"
                  style="width: 100%; height: 100%; object-fit: contain;"
                />
              </button>
            </div>
          </div>

          <!-- Zoom -->
          <div style="margin-top: 20px; padding: 0px 0px 0px 10px;">
            <p style="color: white;">Zoom :</p>
            <div class="btn-group" role="group" aria-label="Basic outlined example">
              <button @click="zoomOut" type="button" class="btn btn-outline-light">-</button>
              <button @click="zoomIn" type="button" class="btn btn-outline-light">+</button>
            </div>
          </div>

          <!-- Bouton de sauvegarde -->
          <div style="margin-top: 20px; padding: 0px 0px 0px 10px;">
            <button @click="saveMosaic" class="btn-save">Création du Pixel Art</button>
          </div>
        </div>
      </div>

      <!-- Overlay pour fermer le sidebar sur mobile -->
      <div v-if="sidebarOpen" class="sidebar-overlay d-lg-none" @click="closeSidebar"></div>

      <!-- Canevas et sliders -->
      <div :class="['canvas-container', 'col-lg-10', 'd-flex', 'flex-column']">
        <div ref="canvasContainer" class="canvas-wrapper">
          <!-- Canevas + slider horizontal -->
          <div class="canvas-with-slider">
            
            <!-- Container pour les deux canvas superposés -->
            <div class="canvas-stack">
              <!-- Canvas principal (grille statique) -->
              <canvas 
                ref="canvas" 
                class="main-canvas">
              </canvas>
              
              <!-- Canvas overlay (pièce fantôme + interactions) -->
              <canvas 
                ref="overlayCanvas"
                tabindex="0"
                @mousedown="onMouseDown"
                @mousemove="onMouseMove"
                @mouseup="onMouseUp"
                @mouseleave="onMouseUp"
                @contextmenu.prevent
                class="overlay-canvas">
              </canvas>
            </div>
            
            <!-- Slider horizontal -->
            <input
              type="range"
              class="form-range viewX"
              min="0"
              max="100"
              v-model="viewX"
            />
          </div>
          
          <!-- Slider vertical -->
          <input
            ref="viewY"
            type="range"
            class="vertical-slider"
            min="0"
            max="100"
            v-model="viewY"
          />
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal de progression -->
  <div class="modal" id="staticBackdrop" data-bs-backdrop="static" ref="progressModal" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Chargement en cours</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar" :style="{ width: progressValue + '%' }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { XMLParser } from 'fast-xml-parser';
import * as bootstrap from 'bootstrap';

// Constantes
const ZOOM_MAX = 5;
const ZOOM_STEP = 0.1;
const ROTATIONS = [0, 90, 180, 270];
const BASE_CELL_SIZE = 10;

export default {
  name: 'MosaicConcepteur',
  
  data() {
    return {
      rows: 10,
      cols: 10,
      grid: [],
      selectPiece: 1,
      tools: [
        { label: 'Pinceau', value: 'brush' },
        { label: 'Seau', value: 'fill' },
        { label: 'Gomme', value: 'scrub' },
        { label: 'Pipette', value: 'pipette'}
      ],
      currentTool: 'brush',
      lasteTool: 'brush',
      isDrawing: false,
      zoom: 1.0,
      zoomMin: 0.2,
      currentDrawnZoom: 1.0,
      isDrawingZoom: false,
      cellSize: 0,
      canvasHeight: 0,
      viewX: 50,
      viewY: 50,
      mosaicId: null,
      xmlContent: null,
      history: [],
      colsString: "",
      rowsString: "",
      idPieceString: "",
      sensString: "",
      progressValue: 0,
      listePiece: null,
      hoverRow: null,
      hoverCol: null,
      ctx: null,
      rotation: 0,
      lastPosedPieceX: null,
      lastPosedPieceY: null,
      isMouseMoveAction: false,
      progressPercent: 0,
      progressStatus: 'idle',
      es: null,
      modalInstance: null,
      imageCache: new Map(),
      imageLoadingPromises: new Map(),
      offscreenCanvas: null,
      offscreenCtx: null,
      isDirty: true,
      scrollDebounceTimer: null,
      isPanning: false,
      panStartX: 0,
      panStartY: 0,
      panStartViewX: 0,
      panStartViewY: 0,
      sidebarOpen: false, // ← AJOUT pour responsive
    };
  },
  
  async mounted() {
    try {
      await this.initializeComponent();
      this.setupWheelZoom();
      this.checkMobileAndCloseSidebar(); // ← AJOUT
      window.addEventListener('resize', this.checkMobileAndCloseSidebar); // ← AJOUT
    } catch (error) {
      this.handleError('Erreur lors de l\'initialisation du composant', error);
    }
  },
  
  watch: {
    viewX() {
      if (this.scrollDebounceTimer) {
        cancelAnimationFrame(this.scrollDebounceTimer);
      }
      
      this.scrollDebounceTimer = requestAnimationFrame(async () => {
        this.isDirty = true;
        await this.drawFullGrid();
        this.copyBufferToCanvas();
        this.drawGhostPiece();
      });
    },
    
    viewY() {
      if (this.scrollDebounceTimer) {
        cancelAnimationFrame(this.scrollDebounceTimer);
      }
      
      this.scrollDebounceTimer = requestAnimationFrame(async () => {
        this.isDirty = true;
        await this.drawFullGrid();
        this.copyBufferToCanvas();
        this.drawGhostPiece();
      });
    },
  },
  
  beforeUnmount() {
    this.cleanupEventListeners();
    window.removeEventListener('resize', this.checkMobileAndCloseSidebar); // ← AJOUT

    const overlay = this.$refs.overlayCanvas;
    if (overlay) {
      overlay.removeEventListener('wheel', this.handleWheel);
    }
    if (this.modalInstance) {
      this.modalInstance.dispose();
    }
    if (this.es) {
      this.es.close();
      this.es = null;
    }
    this.clearImageCache();
  },
  
  methods: {
    // ============================================
    // MÉTHODES RESPONSIVE (AJOUT)
    // ============================================
    
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    
    closeSidebar() {
      this.sidebarOpen = false;
    },
    
    checkMobileAndCloseSidebar() {
      // Fermer automatiquement la sidebar si on passe en mode desktop
      if (window.innerWidth >= 992) {
        this.sidebarOpen = false;
      }
    },
    
    // ============================================
    // INITIALISATION
    // ============================================
    
    async initializeComponent() {
      this.setupModal();
      this.setupEventListeners();
      this.openProgressBar();
      
      this.mosaicId = this.$route.query.mosaicId;
      this.progressValue = 20;
      
      await this.loadPieces();
      this.progressValue = 40;
      
      if (this.mosaicId) {
        await this.loadMosaic();
      } else {
        this.grid = this.createEmptyGrid();
      }
      
      this.loadHistoryFromLocalStorage();
      this.progressValue = 100;
      
      this.initCanvas();
      this.closeProgressBar();
    },
    
    setupModal() {
      const modalElement = this.$refs.progressModal;
      this.modalInstance = new bootstrap.Modal(modalElement);
    },
    
    setupEventListeners() {
      window.addEventListener('resize', this.updateNavbarHeight);
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('beforeunload', this.saveToLocalStorage);
      window.addEventListener('keydown', this.handleKeyDown);
    },
    
    cleanupEventListeners() {
      window.removeEventListener('resize', this.updateNavbarHeight);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('beforeunload', this.saveToLocalStorage);
      window.removeEventListener('keydown', this.handleKeyDown);
    },

    handleResize() {
      // Debounce le resize pour éviter trop d'appels
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      
      this.resizeTimeout = setTimeout(async () => {
        console.log('Resizing canvas...');
        await this.initCanvas();
      }, 200);
    },
    
    // ============================================
    // CHARGEMENT DES DONNÉES
    // ============================================
    
    async loadPieces() {
      const token = localStorage.getItem('token');
      try {
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        const response = await axios.get(`${API_URL}/api/piece/liste`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        this.listePiece = {};
        for (const piece of response.data) {
          piece.shema = JSON.parse(piece.shema);
          this.listePiece[piece.id] = piece;
        }
      } catch (error) {
        this.handleError('Erreur lors du chargement des pièces', error);
        this.grid = this.createEmptyGrid();
      }
    },
    
    async loadMosaic() {
      try {
        this.progressValue = 60;
        
        this.xmlData = await this.loadXmlFile(this.mosaicId);
        this.progressValue = 80;
        
        this.grid = this.createEmptyGrid(this.xmlData);
      } catch (error) {
        this.handleError('Erreur lors du chargement de la mosaïque', error);
        this.grid = this.createEmptyGrid();
      }
    },
    
    async loadXmlFile(name) {
      try {
        const token = localStorage.getItem('token');
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        const response = await axios.get(`${API_URL}/api/xml/${name}`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'text'
        });

        const parser = new XMLParser({
          ignoreAttributes: false,
          attributeNamePrefix: '@_',
          parseAttributeValue: true,
          isArray: (tagName, jpath) => (
            jpath === 'matrix.row' || jpath === 'matrix.row.cell'
          ),
        });

        return parser.parse(response.data);
      } catch (error) {
        this.handleError('Erreur lors du chargement du fichier XML', error);
        return null;
      }
    },
    
    loadHistoryFromLocalStorage() {
      const savedHistory = localStorage.getItem('history' + this.mosaicId);
      if (savedHistory) {
        this.history = JSON.parse(savedHistory);
      }
    },

    async getImage(idPiece) {
      if (idPiece === null || idPiece === undefined) {
        return null;
      }

      const id = String(idPiece);

      if (this.imageCache.has(id)) {
        return this.imageCache.get(id);
      }

      if (this.imageLoadingPromises.has(id)) {
        return await this.imageLoadingPromises.get(id);
      }

      const loadingPromise = this.loadImageFromServer(id);
      this.imageLoadingPromises.set(id, loadingPromise);

      try {
        const image = await loadingPromise;
        this.imageCache.set(id, image);
        this.imageLoadingPromises.delete(id);
        return image;

      } catch (error) {
        this.imageLoadingPromises.delete(id);
        console.warn(`Impossible de charger l'image ${id}:`, error);
        this.imageCache.set(id, null);
        return null;
      }
    },

    loadImageFromServer(idPiece) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const imagePath = `/images/image_piece/${idPiece}.svg`;

        img.onload = () => {
          console.log(`✅ Image ${idPiece} chargée et mise en cache`);
          resolve(img);
        };

        img.onerror = () => {
          reject(new Error(`Échec du chargement de ${imagePath}`));
        };

        img.src = imagePath;
      });
    },
    
    // ============================================
    // CRÉATION DE LA GRILLE
    // ============================================
    
    createEmptyGrid(xmlData) {
      const savedGrid = localStorage.getItem('grid' + this.mosaicId);
      if (savedGrid) {
        try {
          const gridData = JSON.parse(savedGrid);
          if (this.isValidGrid(gridData)) {
            this.grid = gridData;
            this.rows = gridData.length;
            this.cols = gridData[0].length;
            return this.grid;
          }
        } catch (e) {
          console.warn('Grid localStorage invalide, on ignore.', e);
        }
      }

      if (xmlData && xmlData.matrix && xmlData.matrix.row) {
        return this.createGridFromXML(xmlData);
      }

      return this.createBlankObjectGrid();
    },
    
    isValidGrid(gridData) {
      return Array.isArray(gridData) && 
             gridData.length > 0 && 
             Array.isArray(gridData[0]);
    },
    
    createGridFromXML(xmlData) {
      const rowsRaw = xmlData?.matrix?.row;
      const rowsArr = Array.isArray(rowsRaw) ? rowsRaw : (rowsRaw ? [rowsRaw] : []);
      
      const grid = [];
      for (let r = 0; r < rowsArr.length; r++) {
        const rowNode = rowsArr[r] || {};
        let cellsRaw = rowNode.cell;
        const cellsArr = Array.isArray(cellsRaw) ? cellsRaw : (cellsRaw ? [cellsRaw] : []);
        
        const row = [];
        for (let c = 0; c < cellsArr.length; c++) {
          const cellNode = cellsArr[c] || {};
          row.push({
            idPiece: this.toNumOrNull(cellNode['@_idPiece']),
            sens: this.toNumOrNull(cellNode['@_sens']),
            origineX: this.toNumOrNull(cellNode['@_origineX']),
            origineY: this.toNumOrNull(cellNode['@_origineY'])
          });
        }
        grid.push(row);
      }

      this.rows = grid.length;
      this.cols = grid[0] ? grid[0].length : 0;

      if (this.rows == 0 || this.cols == 0) {
        return this.createBlankObjectGrid();
      }

      return grid;
    },
    
    createBlankObjectGrid() {
      const rows = this.rows || 10;
      const cols = this.cols || 10;
      return Array.from({ length: rows }, () =>
        Array.from({ length: cols }, () => ({
          idPiece: null,
          origineY: null,
          origineX: null,
          sens: null,
        }))
      );
    },
    
    toNumOrNull(v) {
      if (v === undefined || v === '' || v === 'null') return null;
      const n = Number(v);
      return Number.isFinite(n) ? n : null;
    },
    
    // ============================================
    // CANVAS
    // ============================================
    
    calculateOptimalZoom(canvasWidth, canvasHeight) {
      const mosaicWidth = this.cols * BASE_CELL_SIZE;
      const mosaicHeight = this.rows * BASE_CELL_SIZE;
      
      const ratioWidth = canvasWidth / mosaicWidth;
      const ratioHeight = canvasHeight / mosaicHeight;
      
      const optimalZoom = Math.min(ratioWidth, ratioHeight);
      
      return Math.min(optimalZoom, ZOOM_MAX);
    },
    
    async initCanvas() {
      const canvas = this.$refs.canvas;
      const overlay = this.$refs.overlayCanvas;
      const container = this.$refs.canvasContainer;

      if (!canvas || !overlay || !container) {
        console.error('Canvas refs not found');
        return;
      }

      // Attendre que le DOM soit stable
      await this.$nextTick();

      const navbarHeight = document.querySelector('.navbar')?.offsetHeight || 0;
      const viewXHeight = 20; // Hauteur approximative du slider
      const windowHeight = window.innerHeight;
      this.canvasHeight = windowHeight - navbarHeight - viewXHeight - 60;

      // Calculer la largeur disponible en tenant compte de la sidebar
      let availableWidth;
      if (window.innerWidth < 768) {
        // Mobile : pleine largeur moins marges
        availableWidth = window.innerWidth - 40;
      } else {
        // Desktop : largeur du container moins marges
        availableWidth = container.clientWidth - 40;
      }

      const width = Math.max(300, availableWidth); // Minimum 300px
      const height = Math.max(300, this.canvasHeight);

      // Appliquer aux canvas visibles
      canvas.width = overlay.width = width;
      canvas.height = overlay.height = height;

      // Calculer le zoom optimal
      const optimalZoom = this.calculateOptimalZoom(width, height);
      this.zoomMin = optimalZoom;
      this.zoom = optimalZoom;

      // Créer/Recréer le canvas offscreen
      this.offscreenCanvas = document.createElement('canvas');
      this.offscreenCanvas.width = width;
      this.offscreenCanvas.height = height;
      this.offscreenCtx = this.offscreenCanvas.getContext('2d');

      // Sliders
      if (this.$refs.viewY) {
        this.$refs.viewY.style.height = `${height}px`;
      }
    
      this.cellSize = BASE_CELL_SIZE * this.zoom;

      console.log('Canvas initialized:', { width, height, cellSize: this.cellSize });

      // Dessiner la grille complète dans le buffer
      await this.drawFullGrid();

      // Copier sur le canvas visible
      this.copyBufferToCanvas();
    },
    
    setupCanvasEventListeners(canvas) {
      canvas.removeEventListener('mousedown', this.onMouseDown);
      canvas.removeEventListener('mousemove', this.onMouseMove);
      canvas.removeEventListener('mouseup', this.onMouseUp);
      canvas.removeEventListener('mouseleave', this.onMouseUp);
      canvas.removeEventListener('mouseleave', this.onMouseLeave);

      canvas.addEventListener('mousedown', this.onMouseDown);
      canvas.addEventListener('mousemove', this.onMouseMove);
      canvas.addEventListener('mouseup', this.onMouseUp);
      canvas.addEventListener('mouseleave', this.onMouseUp);
      canvas.addEventListener('mouseleave', this.onMouseLeave);
    },
    
    async drawGrid() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext('2d');
      const cellSize = this.cellSize;
      const totalWidth = this.cols * cellSize;
      const totalHeight = this.rows * cellSize;
      const offsetX = (this.viewX / 100) * (totalWidth - canvas.width);
      const offsetY = (this.viewY / 100) * (totalHeight - canvas.height);
      const basePath = '/images/image_piece/';
      
      const offCanvas = document.createElement('canvas');
      offCanvas.width = canvas.width;
      offCanvas.height = canvas.height;
      const offCtx = offCanvas.getContext('2d');
      
      offCtx.save();
      offCtx.translate(-offsetX, -offsetY);
      
      const promises = this.createImagePromises(basePath, cellSize);
      const images = await Promise.all(promises);
      
      this.drawImages(offCtx, images, cellSize);
      offCtx.restore();
      
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(offCanvas, 0, 0);
    },

    async drawFullGrid() {
      if (!this.offscreenCtx) {
        console.warn('OffscreenCtx not initialized');
        return;
      }
      
      const cellSize = this.cellSize;
      
      const bounds = this.getVisibleBounds();
      const { offsetX, offsetY } = bounds;
      
      this.offscreenCtx.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height);
      
      this.offscreenCtx.save();
      this.offscreenCtx.translate(-offsetX, -offsetY);
      
      const basePath = '/images/image_piece/';
      const promises = this.createImagePromises(basePath, cellSize);
      const images = await Promise.all(promises);
      
      console.log(`Drawing ${images.length} images on grid`);
      
      this.drawImages(this.offscreenCtx, images, cellSize);
      this.offscreenCtx.restore();
      
      this.isDirty = false;
    },

    async redrawSinglePiece(row, col) {
      if (!this.offscreenCtx) {
        await this.drawFullGrid();
        this.copyBufferToCanvas();
        return;
      }
      
      const cellSize = this.cellSize;
      const totalWidth = this.cols * cellSize;
      const totalHeight = this.rows * cellSize;
      const offsetX = (this.viewX / 100) * (totalWidth - this.offscreenCanvas.width);
      const offsetY = (this.viewY / 100) * (totalHeight - this.offscreenCanvas.height);
      
      const { row: principalRow, col: principalCol, cell: principalCell } = this.getPrincipalCell(row, col);
      
      const idPiece = principalCell.idPiece;
      
      if (idPiece === null) {
        const x = col * cellSize - offsetX;
        const y = row * cellSize - offsetY;
        this.offscreenCtx.clearRect(x, y, cellSize, cellSize);
        
        this.offscreenCtx.strokeStyle = '#ccc';
        this.offscreenCtx.strokeRect(x, y, cellSize, cellSize);
      } else {
        await this.drawPieceOnBuffer(principalRow, principalCol, offsetX, offsetY);
      }
      
      this.copyBufferToCanvas();
    },

    getVisibleBounds() {
      const canvas = this.$refs.canvas;
      const cellSize = this.cellSize;
      const totalWidth = this.cols * cellSize;
      const totalHeight = this.rows * cellSize;
      
      const offsetX = (this.viewX / 100) * (totalWidth - canvas.width);
      const offsetY = (this.viewY / 100) * (totalHeight - canvas.height);
      
      const rowStart = Math.floor(offsetY / cellSize);
      const rowEnd = Math.ceil((offsetY + canvas.height) / cellSize);
      const colStart = Math.floor(offsetX / cellSize);
      const colEnd = Math.ceil((offsetX + canvas.width) / cellSize);
      
      const margin = 10;
      
      return {
        rowStart: Math.max(0, rowStart - margin),
        rowEnd: Math.min(this.rows, rowEnd + margin),
        colStart: Math.max(0, colStart - margin),
        colEnd: Math.min(this.cols, colEnd + margin),
        offsetX,
        offsetY
      };
    },

    clearPieceArea(row, col, offsetX, offsetY) {
      const cellSize = this.cellSize;
      
      const { row: principalRow, col: principalCol, cell: principalCell } = this.getPrincipalCell(row, col);
      
      const idPiece = principalCell.idPiece;
      
      if (!idPiece) {
        const x = col * cellSize - offsetX;
        const y = row * cellSize - offsetY;
        this.offscreenCtx.clearRect(x, y, cellSize, cellSize);
        return;
      }
      
      const piece = this.listePiece[idPiece];
      const sens = principalCell.sens;
      
      let width = piece.shema.taileX[0] * cellSize;
      let height = piece.shema.taileY[0] * cellSize;
      
      if (sens === 90 || sens === 270) {
        [width, height] = [height, width];
      }
      
      const x = principalCol * cellSize - offsetX;
      const y = principalRow * cellSize - offsetY;
      
      this.offscreenCtx.save();
      
      switch (sens) {
        case 0:
        case 90:
          this.offscreenCtx.clearRect(x, y, width, height);
          break;
        case 180:
          this.offscreenCtx.clearRect(x - width + cellSize, y, width, height);
          break;
        case 270:
          this.offscreenCtx.clearRect(x, y - height + cellSize, width, height);
          break;
        default:
          this.offscreenCtx.clearRect(x, y, width, height);
      }
      
      this.offscreenCtx.restore();
    },

    async drawPieceOnBuffer(row, col, offsetX, offsetY) {
      const cellSize = this.cellSize;
      
      const { row: principalRow, col: principalCol, cell: principalCell } = this.getPrincipalCell(row, col);
      
      const idPiece = principalCell.idPiece;
      const sens = principalCell.sens;
      
      if (!idPiece) return;
      
      const img = await this.getImage(idPiece);
      if (!img) return;
      
      const x = principalCol * cellSize - offsetX;
      const y = principalRow * cellSize - offsetY;
      
      const piece = this.listePiece[idPiece];
      let drawWidth = piece.shema.taileX[0] * cellSize;
      let drawHeight = piece.shema.taileY[0] * cellSize;
      
      if (sens === 90 || sens === 270) {
        [drawWidth, drawHeight] = [drawHeight, drawWidth];
      }
      
      this.offscreenCtx.save();
      
      switch (sens) {
        case 0:
        case 90:
          this.offscreenCtx.clearRect(x, y, drawWidth, drawHeight);
          break;
        case 180:
          this.offscreenCtx.clearRect(x - drawWidth + cellSize, y, drawWidth, drawHeight);
          break;
        case 270:
          this.offscreenCtx.clearRect(x, y - drawHeight + cellSize, drawWidth, drawHeight);
          break;
      }
      
      this.drawRotatedImage(
        this.offscreenCtx,
        { img, x, y, idPiece, sens },
        drawWidth,
        drawHeight,
        cellSize
      );
      
      this.offscreenCtx.restore();
      
      this.offscreenCtx.strokeStyle = '#ccc';
      switch (sens) {
        case 0:
        case 90:
          this.offscreenCtx.strokeRect(x, y, drawWidth, drawHeight);
          break;
        case 180:
          this.offscreenCtx.strokeRect(x + cellSize, y, -drawWidth, drawHeight);
          break;
        case 270:
          this.offscreenCtx.strokeRect(x, y + cellSize, drawWidth, -drawHeight);
          break;
      }
    },

    copyBufferToCanvas() {
      if (!this.offscreenCanvas) return;
      
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext('2d');
      
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(this.offscreenCanvas, 0, 0);
    },

    async drawGhostPiece() {
      const overlay = this.$refs.overlayCanvas;
      if (!overlay) return;
      
      const ctx = overlay.getContext('2d');
      const canvas = this.$refs.canvas;
      
      ctx.clearRect(0, 0, overlay.width, overlay.height);
      
      if (this.currentTool !== 'brush' || 
          this.hoverRow === null || 
          this.hoverCol === null || 
          this.selectPiece === null) {
        return;
      }
      
      const cellSize = this.cellSize;
      const totalWidth = this.cols * cellSize;
      const totalHeight = this.rows * cellSize;
      const offsetX = (this.viewX / 100) * (totalWidth - canvas.width);
      const offsetY = (this.viewY / 100) * (totalHeight - canvas.height);
      
      const ghostX = this.hoverCol * cellSize - offsetX;
      const ghostY = this.hoverRow * cellSize - offsetY;
      
      const img = await this.getImage(this.selectPiece);
      
      if (img) {
        ctx.save();
        ctx.globalAlpha = 0.4;
        
        const { drawWidth, drawHeight } = this.getPreviewDimensions(cellSize);
        this.drawRotatedPreview(ctx, img, ghostX, ghostY, drawWidth, drawHeight, cellSize);
        
        ctx.restore();
      }
    },

    clearImageCache() {
      this.imageCache.clear();
      this.imageLoadingPromises.clear();
      console.log('🗑️ Cache d\'images vidé');
    },
    
    invalidateImage(idPiece) {
      const id = String(idPiece);
      this.imageCache.delete(id);
      this.imageLoadingPromises.delete(id);
      console.log(`🗑️ Image ${id} invalidée du cache`);
    },
    
    async preloadImages(pieceIds) {
      console.log(`⏳ Pré-chargement de ${pieceIds.length} images...`);
      
      const promises = pieceIds.map(id => this.getImage(id));
      await Promise.all(promises);
      
      console.log(`✅ ${pieceIds.length} images pré-chargées`);
    },
    
    getCacheStats() {
      return {
        cachedImages: this.imageCache.size,
        loadingImages: this.imageLoadingPromises.size,
        memoryEstimate: `~${(this.imageCache.size * 50 / 1024).toFixed(2)} MB`
      };
    },
    
    createImagePromises(basePath, cellSize) {
      const promises = [];
      
      const bounds = this.getVisibleBounds();
      const { rowStart, rowEnd, colStart, colEnd } = bounds;
      
      for (let row = rowStart; row < rowEnd; row++) {
        for (let col = colStart; col < colEnd; col++) {
          const cell = this.grid[row][col];
          const idPiece = cell.idPiece;
          
          const x = col * cellSize;
          const y = row * cellSize;
          
          const promise = this.getImage(idPiece).then(img => {
            if (img) {
              return { 
                img, 
                x, 
                y, 
                idPiece: cell.idPiece, 
                sens: cell.sens 
              };
            }
            return { 
              img: null, 
              x, 
              y, 
              idPiece: null, 
              sens: null 
            };
          });
          
          promises.push(promise);
        }
      }
      
      console.log(`🎯 Viewport culling: ${promises.length} cellules au lieu de ${this.rows * this.cols}`);
      
      return promises;
    },
    
    drawImages(offCtx, images, cellSize) {
      for (const item of images) {
        if (!item) continue;
        
        const { drawWidth, drawHeight } = this.getDrawDimensions(item, cellSize);
        
        offCtx.save();
        this.drawRotatedImage(offCtx, item, drawWidth, drawHeight, cellSize);
        offCtx.restore();
        
        this.drawCellBorder(offCtx, item, drawWidth, drawHeight);
      }
    },
    
    getDrawDimensions(item, cellSize) {
      let drawWidth, drawHeight;
      if(item.idPiece == null) {
        drawWidth = 1;
        drawHeight = 1;
        console.log("piece vide : ",item);
        return { drawWidth, drawHeight };
      }
      if (item.sens == 90 || item.sens == 270) {
        drawWidth = cellSize * this.listePiece[item.idPiece]['shema']['taileY'];
        drawHeight = cellSize * this.listePiece[item.idPiece]['shema']['taileX'];
      } else {
        drawWidth = cellSize * this.listePiece[item.idPiece]['shema']['taileX'];
        drawHeight = cellSize * this.listePiece[item.idPiece]['shema']['taileY'];
      }
      
      return { drawWidth, drawHeight };
    },
    
    drawRotatedImage(offCtx, item, drawWidth, drawHeight, cellSize) {
      switch (item.sens) {
        case 0:
          offCtx.drawImage(item.img, item.x, item.y, drawWidth, drawHeight);
          break;
          
        case 90:
          offCtx.translate(item.x + drawWidth / 2, item.y + drawHeight / 2);
          offCtx.rotate(90 * Math.PI / 180);
          offCtx.drawImage(item.img, -drawHeight / 2, -drawWidth / 2, drawHeight, drawWidth);
          break;
          
        case 180:
          offCtx.translate(item.x + drawWidth, item.y + drawHeight);
          offCtx.rotate(90 * Math.PI / 90);
          offCtx.drawImage(item.img, drawWidth - cellSize, drawHeight, drawWidth, -drawHeight);
          break;
          
        case 270:
          offCtx.translate(item.x + drawWidth / 2, item.y - drawHeight + 2 * cellSize);
          offCtx.rotate(270 * Math.PI / 180);
          offCtx.drawImage(item.img, cellSize - drawHeight, -drawWidth / 2, drawHeight, drawWidth);
          break;
      }
    },
    
    drawCellBorder(offCtx, item, drawWidth, drawHeight) {
      offCtx.strokeStyle = '#ccc';
      
      switch (item.sens) {
        case 0:
        case 90:
          offCtx.strokeRect(item.x, item.y, drawWidth, drawHeight);
          break;
          
        case 180:
          offCtx.strokeRect(item.x + this.cellSize, item.y, -drawWidth, drawHeight);
          break;
          
        case 270:
          offCtx.strokeRect(item.x, item.y + this.cellSize, drawWidth, -drawHeight);
          break;
      }
    },
    
    drawHoverPreview(ctx, offsetX, offsetY, cellSize) {
      if (this.currentTool !== 'brush' || 
          this.hoverRow === null || 
          this.hoverCol === null || 
          this.selectPiece === null) {
        return;
      }
      
      const ghostX = this.hoverCol * cellSize - offsetX;
      const ghostY = this.hoverRow * cellSize - offsetY;
      const img = new Image();
      img.src = `/images/image_piece/${this.selectPiece}.svg`;
      
      img.onload = () => {
        ctx.save();
        ctx.globalAlpha = 0.4;
        
        const { drawWidth, drawHeight } = this.getPreviewDimensions(cellSize);
        this.drawRotatedPreview(ctx, img, ghostX, ghostY, drawWidth, drawHeight, cellSize);
        
        ctx.restore();
      };
    },
    
    getPreviewDimensions(cellSize) {
      let drawWidth, drawHeight;
      
      if (this.rotation == 90 || this.rotation == 270) {
        drawWidth = cellSize * this.listePiece[this.selectPiece]['shema']['taileY'];
        drawHeight = cellSize * this.listePiece[this.selectPiece]['shema']['taileX'];
      } else {
        drawWidth = cellSize * this.listePiece[this.selectPiece]['shema']['taileX'];
        drawHeight = cellSize * this.listePiece[this.selectPiece]['shema']['taileY'];
      }
      
      return { drawWidth, drawHeight };
    },
    
    drawRotatedPreview(ctx, img, ghostX, ghostY, drawWidth, drawHeight, cellSize) {
      switch (this.rotation) {
        case 0:
          ctx.drawImage(img, ghostX, ghostY, drawWidth, drawHeight);
          break;
          
        case 90:
          ctx.translate(ghostX + drawWidth / 2, ghostY + drawHeight / 2);
          ctx.rotate(90 * Math.PI / 180);
          ctx.drawImage(img, -drawHeight / 2, -drawWidth / 2, drawHeight, drawWidth);
          break;
          
        case 180:
          ctx.translate(ghostX + drawWidth, ghostY + drawHeight);
          ctx.rotate(90 * Math.PI / 90);
          ctx.drawImage(img, drawWidth - cellSize, drawHeight, drawWidth, -drawHeight);
          break;
          
        case 270:
          ctx.translate(ghostX + drawWidth / 2, ghostY - drawHeight + 2 * cellSize);
          ctx.rotate(270 * Math.PI / 180);
          ctx.drawImage(img, cellSize - drawHeight, -drawWidth / 2, drawHeight, drawWidth);
          break;
      }
    },
    
    // ============================================
    // GESTION DES ÉVÉNEMENTS
    // ============================================

    setupWheelZoom() {
      const overlay = this.$refs.overlayCanvas;
      if (!overlay) return;

      overlay.addEventListener('wheel', this.handleWheel, { passive: false });
    },

    handleWheel(event) {
      event.preventDefault();

      if (event.deltaY < 0) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    },
    
    handleKeyDown(e) {
      if (e.key == 'r' || e.key == 'R') {
        this.rotateClockwise();
        this.drawGhostPiece();
        return;
      }
      
      if (e.ctrlKey && (e.key == 'z' || e.key == 'Z')) {
        this.undoLastAction();
      }
    },
    
    rotateClockwise() {
      const currentIndex = ROTATIONS.indexOf(this.rotation);
      this.rotation = ROTATIONS[(currentIndex + 1) % ROTATIONS.length];
    },
    
    undoLastAction() {
      if (this.history.length === 0) return;
      
      const lastState = this.history.pop();
      
      switch (lastState.tool) {
        case 'brush':
          this.undoBrush(lastState);
          break;
        case 'scrub':
          this.undoScrub(lastState);
          break;
        case 'fill':
          this.undoFill(lastState);
          break;
      }
    },
    
    undoBrush(lastState) {
      const idPieces = this.parseString(lastState.idPiece, true);
      const cols = this.parseString(lastState.col);
      const rows = this.parseString(lastState.row);
      const senss = this.parseString(lastState.sens);
      
      if (rows.length > 0 && cols.length > 0) {
        this.scrubCell(rows[0], cols[0]);
      }

      for (let i = 0; i < cols.length; i++) {
        if (idPieces[i] != null) {
          this.paintCell(rows[i], cols[i], idPieces[i], senss[i]);
        } else {
          this.clearCell(rows[i], cols[i]);
        }
      }
    },
    
    undoScrub(lastState) {
      this.paintCell(lastState.row, lastState.col, lastState.idPiece, lastState.sens);
    },
    
    undoFill(lastState) {
      const cols = this.parseString(lastState.col);
      const rows = this.parseString(lastState.row);
      const idPieces = this.parseString(lastState.idPiece, true);
      const senss = this.parseString(lastState.sens);

      const restoredCells = new Set();

      for (let i = 0; i < cols.length; i++) {
        if (idPieces[i] != null && !isNaN(idPieces[i])) {
          this.paintCell(rows[i], cols[i], idPieces[i], senss[i]);

          const occupiedCells = this.getOccupiedCells(rows[i], cols[i], idPieces[i], senss[i]);
          occupiedCells.forEach(cell => restoredCells.add(cell));

        } else {
          const cellKey = `${rows[i]},${cols[i]}`;

          if (!restoredCells.has(cellKey)) {
            this.scrubCell(rows[i], cols[i]);
          }
        }
      }
    },

    getOccupiedCells(row, col, idPiece, rotation) {
      const occupiedCells = [];
      const espaceOcupes = this.listePiece[idPiece]['shema']['espaceOccupe'];

      for (const espaceOcupe of espaceOcupes) {
        const espaceParse = espaceOcupe.split('-').filter(part => part !== '').map(Number);
        let espaceHight = espaceParse[0];
        let espaceWidth = espaceParse[1];

        if (rotation == 90 || rotation == 270) {
          [espaceWidth, espaceHight] = [espaceHight, espaceWidth];
        }

        const coords = this.getTargetCoords(row, col, espaceHight, espaceWidth, rotation);

        occupiedCells.push(`${coords.row},${coords.col}`);
      }

      return occupiedCells;
    },
    
    parseString(str, allowNull = false) {
      return str.split('-')
        .filter(part => part !== '')
        .map(part => {
          if (allowNull && part === 'null') return null;
          return Number(part);
        });
    },
    
    onMouseDown(e) {
      if (e.button === 2) {
        e.preventDefault();
        this.isPanning = true;
        this.panStartX = e.clientX;
        this.panStartY = e.clientY;
        this.panStartViewX = this.viewX;
        this.panStartViewY = this.viewY;

        this.$refs.overlayCanvas.style.cursor = 'grabbing';
        return;
      }

      if (e.button !== 0) return;
  
      this.isDrawing = true;
      const { row, col } = this.getCellFromEvent(e);
      
      if (!this.isValidCell(row, col)) return;
      
      const previousPiece = this.grid[row][col]["idPiece"];
      const previousSens = this.grid[row][col]["sens"];
      
      switch (this.currentTool) {
        case 'brush':
          this.handleBrushMouseDown(row, col, previousPiece, previousSens);
          break;
        case 'fill':
          this.handleFillMouseDown(row, col, previousPiece);
          break;
        case 'scrub':
          this.handleScrubMouseDown(row, col, previousPiece);
          break;
        case 'pipette':
          this.handlePipetteMouseDown(row, col, previousPiece, previousSens)
      }
    },
    
    handleBrushMouseDown(row, col, previousPiece, previousSens) {
      if (previousPiece != this.selectPiece || this.rotation != previousSens) {
        const historyData = this.collectPieceData(row, col, this.rotation);
        
        if (historyData) {
          this.history.push({
            tool: this.currentTool,
            idPiece: historyData.idPieceString,
            row: historyData.rowString,
            col: historyData.colString,
            sens: historyData.sensString
          });
          
          this.lastPosedPieceX = col;
          this.lastPosedPieceY = row;
          this.isMouseMoveAction = false;
          
          this.paintCell(row, col, this.selectPiece, this.rotation);
        }
      }
    },
    
    handleFillMouseDown(row, col, previousPiece) {
      if (previousPiece != this.selectPiece) {
        let positionY = row;
        let positionX = col;
        
        if (this.grid[positionY][positionX]["origineX"] != null && 
            this.grid[positionY][positionX]["origineY"] != null) {
          positionY = this.grid[row][col]["origineY"];
          positionX = this.grid[row][col]["origineX"];
        }
        
        this.fill(row, col, this.grid[positionY][positionX]["idPiece"], this.selectPiece, this.rotation);
        
        if (this.rowsString != "") {
          this.history.push({
            tool: this.currentTool,
            idPiece: this.idPieceString,
            row: this.rowsString,
            col: this.colsString,
            sens: this.sensString
          });
        }
        
        this.rowsString = "";
        this.colsString = "";
        this.idPieceString = "";
        this.sensString = "";
      }
    },
    
    handleScrubMouseDown(row, col, previousPiece) {
      if (previousPiece != null && this.grid[row][col]["origineX"] == null) {
        this.history.push({
          tool: this.currentTool,
          idPiece: previousPiece,
          row,
          col,
          sens: this.grid[row][col]["sens"]
        });
        this.scrubCell(row, col);
      } else if (previousPiece == null && this.grid[row][col]["origineX"] != null) {
        const rowH = this.grid[row][col]["origineY"];
        const colH = this.grid[row][col]["origineX"];
        const previousPieceH = this.grid[rowH][colH]["idPiece"];
        const sensH = this.grid[rowH][colH]["sens"];
        
        this.history.push({
          tool: this.currentTool,
          idPiece: previousPieceH,
          row: rowH,
          col: colH,
          sens: sensH
        });
        this.scrubCell(row, col);
      }
    },

    handlePipetteMouseDown(row, col, previousPiece, previousSens) {
      if (previousPiece != null) {
        this.selectPiece = previousPiece
        this.rotation = previousSens
      } else if(this.grid[row][col]["origineX"] != null) {
        let origineY = this.grid[row][col]["origineY"]
        let origineX = this.grid[row][col]["origineX"]
        this.selectPiece = this.grid[origineY][origineX]["idPiece"]
        this.rotation = this.grid[origineY][origineX]["sens"]
      }
      this.currentTool = this.lasteTool
    },
    
    onMouseMove(e) {
      const { row, col } = this.getCellFromEvent(e);

      if (!this.isPanning && !this.isDrawing) {
        this.$refs.overlayCanvas.style.cursor = 'crosshair';
      }

      if (this.isPanning) {
        const deltaX = e.clientX - this.panStartX;
        const deltaY = e.clientY - this.panStartY;
        
        const canvas = this.$refs.canvas;
        const totalWidth = this.cols * this.cellSize;
        const totalHeight = this.rows * this.cellSize;
        
        const maxScrollX = totalWidth - canvas.width;
        const maxScrollY = totalHeight - canvas.height;
        
        if (maxScrollX > 0) {
          const percentDeltaX = (deltaX / maxScrollX) * 100;
          this.viewX = Math.max(0, Math.min(100, this.panStartViewX - percentDeltaX));
        }
        
        if (maxScrollY > 0) {
          const percentDeltaY = (deltaY / maxScrollY) * 100;
          this.viewY = Math.max(0, Math.min(100, this.panStartViewY - percentDeltaY));
        }
        
        return;
      }
  
      if (row != this.hoverRow || col != this.hoverCol) {
        this.hoverRow = row;
        this.hoverCol = col;
        this.drawGhostPiece();
      }
      
      if (!this.isDrawing || this.currentTool == 'fill') return;
      if (!this.isValidCell(row, col)) return;
      
      const previousPiece = this.grid[row][col]["idPiece"];
      const previousSens = this.grid[row][col]["sens"];
      
      if (this.currentTool == 'brush') {
        this.handleBrushMouseMove(row, col, previousPiece, previousSens);
      } else if (this.currentTool == 'scrub') {
        this.handleScrubMouseMove(row, col, previousPiece);
      }
    },
    
    handleBrushMouseMove(row, col, previousPiece, previousSens) {
      if (previousPiece != this.selectPiece || this.rotation != previousSens) {
        if (this.isOverSamePiece(row, col)) return;
        
        const historyData = this.collectPieceData(row, col, this.rotation);
        
        if (historyData) {
          this.lastPosedPieceX = col;
          this.lastPosedPieceY = row;
          this.isMouseMoveAction = true;
          
          this.history.push({
            tool: this.currentTool,
            idPiece: historyData.idPieceString,
            row: historyData.rowString,
            col: historyData.colString,
            sens: historyData.sensString
          });
          
          this.paintCell(row, col, this.selectPiece, this.rotation);
        }
      }
    },
    
    handleScrubMouseMove(row, col, previousPiece) {
      if (previousPiece != null && this.grid[row][col]["origineX"] == null) {
        this.history.push({
          tool: this.currentTool,
          idPiece: previousPiece,
          row,
          col,
          sens: this.grid[row][col]["sens"]
        });
        this.scrubCell(row, col);
      } else if (previousPiece == null && this.grid[row][col]["origineX"] != null) {
        const rowH = this.grid[row][col]["origineY"];
        const colH = this.grid[row][col]["origineX"];
        const previousPieceH = this.grid[rowH][colH]["idPiece"];
        const sensH = this.grid[rowH][colH]["sens"];
        
        this.history.push({
          tool: this.currentTool,
          idPiece: previousPieceH,
          row: rowH,
          col: colH,
          sens: sensH
        });
        this.scrubCell(row, col);
        this.drawGrid();
      }
    },
    
    isOverSamePiece(row, col) {
      const espaceOcupes = this.listePiece[this.selectPiece]['shema']['espaceOccupe'];
      const espaceOcupeWidth = this.listePiece[this.selectPiece]['shema']['taileX'][0];
      const espaceOcupeHight = this.listePiece[this.selectPiece]['shema']['taileY'][0];
      
      const bounds = this.getPieceBounds(row, col, espaceOcupeWidth, espaceOcupeHight);
      if (!this.areBoundsValid(bounds)) return true;
      
      return this.checkSamePieceCollision(row, col, espaceOcupes);
    },
    
    getPieceBounds(row, col, width, height) {
      switch (this.rotation) {
        case 0:
          return {
            minRow: row,
            maxRow: row + height - 1,
            minCol: col,
            maxCol: col + width - 1
          };
        case 90:
          return {
            minRow: row,
            maxRow: row + width - 1,
            minCol: col,
            maxCol: col + height - 1
          };
        case 180:
          return {
            minRow: row,
            maxRow: row + height - 1,
            minCol: col - width + 1,
            maxCol: col
          };
        case 270:
          return {
            minRow: row - width + 1,
            maxRow: row,
            minCol: col,
            maxCol: col + height - 1
          };
        default:
          return null;
      }
    },
    
    areBoundsValid(bounds) {
      return bounds.minRow >= 0 && 
             bounds.maxRow < this.rows && 
             bounds.minCol >= 0 && 
             bounds.maxCol < this.cols;
    },
    
    checkSamePieceCollision(row, col, espaceOcupes) {
      for (const espaceOcupe of espaceOcupes) {
        const espaceParse = espaceOcupe.split('-').filter(part => part !== '').map(Number);
        let espaceHight = espaceParse[0];
        let espaceWidth = espaceParse[1];
        
        if (this.rotation == 90 || this.rotation == 270) {
          [espaceWidth, espaceHight] = [espaceHight, espaceWidth];
        }
        
        const targetCoords = this.getTargetCoords(row, col, espaceHight, espaceWidth);
        
        if (this.isOnLastPosedPiece(targetCoords.row, targetCoords.col)) {
          return true;
        }
      }
      
      return false;
    },

    getTargetCoords(row, col, espaceHight, espaceWidth, rotation = null) {
      const rot = rotation !== null ? rotation : this.rotation;
      switch (rot) {
        case 0:
        case 90:
          return { row: row + espaceHight - 1, col: col + espaceWidth - 1 };
        case 180:
          return { row: row + espaceHight - 1, col: col - espaceWidth + 1 };
        case 270:
          return { row: row - espaceHight + 1, col: col + espaceWidth - 1 };
        default:
          return { row, col };
      }
    },
    
    isOnLastPosedPiece(row, col) {
      if (this.lastPosedPieceY == row && this.lastPosedPieceX == col) {
        return true;
      }
      
      const cell = this.grid[row][col];
      if (cell["origineX"] == this.lastPosedPieceX && 
          cell["origineY"] == this.lastPosedPieceY) {
        return true;
      }
      
      return false;
    },
    
    onMouseUp() {
      if (this.isPanning) {
        this.isPanning = false;
        this.$refs.overlayCanvas.style.cursor = 'crosshair';
        return;
      }
      if (this.isMouseMoveAction) {
        this.lastPosedPieceX = null;
        this.lastPosedPieceY = null;
      }
      this.isDrawing = false;
    },
    
    onMouseLeave() {
      this.hoverRow = null;
      this.hoverCol = null;
      this.drawGrid();
    },
    
    getCellFromEvent(e) {
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;
      const x = (e.clientX - rect.left) * scaleX;
      const y = (e.clientY - rect.top) * scaleY;

      const totalWidth = this.cols * this.cellSize;
      const totalHeight = this.rows * this.cellSize;

      const offsetX = (this.viewX / 100) * (totalWidth - canvas.width);
      const offsetY = (this.viewY / 100) * (totalHeight - canvas.height);

      const adjustedX = x + offsetX;
      const adjustedY = y + offsetY;

      const col = Math.floor(adjustedX / this.cellSize);
      const row = Math.floor(adjustedY / this.cellSize);

      return { row, col };
    },
    
    isValidCell(row, col) {
      return row >= 0 && row < this.rows && col >= 0 && col < this.cols;
    },
    
    // ============================================
    // MANIPULATION DE LA GRILLE
    // ============================================
    
    collectPieceData(row, col, rotation) {
      let idPieceString = "";
      let rowString = "";
      let colString = "";
      let sensString = "";
      
      const espaceOcupes = this.listePiece[this.selectPiece]['shema']['espaceOccupe'];
      const espaceOcupeWidth = this.listePiece[this.selectPiece]['shema']['taileX'][0];
      const espaceOcupeHight = this.listePiece[this.selectPiece]['shema']['taileY'][0];
      
      const bounds = this.getPieceBounds(row, col, espaceOcupeWidth, espaceOcupeHight);
      if (!this.areBoundsValid(bounds)) return null;
      
      const recordedPieces = new Set();
      
      for (const espaceOcupe of espaceOcupes) {
        const espaceParse = espaceOcupe.split('-').filter(part => part !== '').map(Number);
        let espaceHight = espaceParse[0];
        let espaceWidth = espaceParse[1];
        
        if (rotation == 90 || rotation == 270) {
          [espaceWidth, espaceHight] = [espaceHight, espaceWidth];
        }
        
        const coords = this.getTargetCoords(row, col, espaceHight, espaceWidth, rotation);
        
        let originRow = coords.row;
        let originCol = coords.col;
        
        if (this.grid[coords.row][coords.col]["origineX"] != null) {
          originRow = this.grid[coords.row][coords.col]["origineY"];
          originCol = this.grid[coords.row][coords.col]["origineX"];
        }
        
        const pieceKey = `${originRow},${originCol}`;
        
        if (!recordedPieces.has(pieceKey)) {
          recordedPieces.add(pieceKey);
          
          const idPiece = this.grid[originRow][originCol]["idPiece"];
          const sens = this.grid[originRow][originCol]["sens"];
          
          idPieceString += idPiece + "-";
          rowString += originRow + "-";
          colString += originCol + "-";
          sensString += sens + "-";
        }
      }
      
      return { idPieceString, rowString, colString, sensString };
    },
    
    async scrubCell(row, col) {
      console.log("scrubCell : ", row, col);
      if (!this.isValidCell(row, col)) return;
      
      let rowScrub = row;
      let colScrub = col;
      
      if (this.grid[row][col]["origineX"] != null) {
        rowScrub = this.grid[row][col]["origineY"];
        colScrub = this.grid[row][col]["origineX"];
      }
      
      const idPiece = this.grid[rowScrub][colScrub]["idPiece"];
      if (idPiece == null) return;
      
      const espaceOcupes = this.listePiece[idPiece]['shema']['espaceOccupe'];
      const sens = this.grid[rowScrub][colScrub]["sens"];
      
      const affectedCells = new Set();
      
      for (const espaceOcupe of espaceOcupes) {
        const espaceParse = espaceOcupe.split('-').filter(part => part !== '').map(Number);
        let espaceHight = espaceParse[0];
        let espaceWidth = espaceParse[1];
        
        if (sens == 90 || sens == 270) {
          [espaceWidth, espaceHight] = [espaceHight, espaceWidth];
        }
        
        const coords = this.getScrubCoords(rowScrub, colScrub, espaceHight, espaceWidth, sens);
        
        this.clearCell(coords.row, coords.col);
        affectedCells.add(`${coords.row},${coords.col}`);
      }
      
      await this.redrawAffectedCells(affectedCells);
    },
    
    getScrubCoords(rowScrub, colScrub, espaceHight, espaceWidth, sens) {
      switch (sens) {
        case 0:
        case 90:
          return { row: rowScrub + espaceHight - 1, col: colScrub + espaceWidth - 1 };
        case 180:
          return { row: rowScrub + espaceHight - 1, col: colScrub - espaceWidth + 1 };
        case 270:
          return { row: rowScrub - espaceHight + 1, col: colScrub + espaceWidth - 1 };
        default:
          return { row: rowScrub, col: colScrub };
      }
    },

    getPrincipalCell(row, col) {
      const cell = this.grid[row][col];

      if (cell.origineX === null && cell.origineY === null) {
        return { row, col, cell };
      }

      if (cell.origineX !== null && cell.origineY !== null) {
        const originRow = cell.origineY;
        const originCol = cell.origineX;
        return {
          row: originRow,
          col: originCol,
          cell: this.grid[originRow][originCol]
        };
      }

      return { row, col, cell };
    },
    
    clearCell(row, col) {
      this.grid[row][col]["idPiece"] = null;
      this.grid[row][col]["origineX"] = null;
      this.grid[row][col]["origineY"] = null;
      this.grid[row][col]["sens"] = null;
    },
    
    async paintCell(row, col, idPiece, rotation) {
      console.log("paintCell : ", row, col, idPiece, rotation);
      if (!this.isValidCell(row, col)) return;
      
      const espaceOcupes = this.listePiece[idPiece]['shema']['espaceOccupe'];
      
      const affectedCells = new Set();
      affectedCells.add(`${row},${col}`);
      
      for (const espaceOcupe of espaceOcupes) {
        const espaceParse = espaceOcupe.split('-').filter(part => part !== '').map(Number);
        let espaceHight = espaceParse[0];
        let espaceWidth = espaceParse[1];
        
        if (rotation == 90 || rotation == 270) {
          [espaceWidth, espaceHight] = [espaceHight, espaceWidth];
        }
        
        const coords = this.getTargetCoords(row, col, espaceHight, espaceWidth, rotation);
        
        affectedCells.add(`${coords.row},${coords.col}`);
        
        if (this.grid[coords.row][coords.col]["origineY"] != null) {
          const origY = this.grid[coords.row][coords.col]["origineY"];
          const origX = this.grid[coords.row][coords.col]["origineX"];
          this.scrubCell(origY, origX);
          affectedCells.add(`${origY},${origX}`);
        }
        
        if (this.grid[coords.row][coords.col]["idPiece"] != null) {
          const currentPiece = this.listePiece[this.grid[coords.row][coords.col]["idPiece"]];
          if (currentPiece && 
              (currentPiece['shema']['taileX'] > 1 || currentPiece['shema']['taileY'] > 1)) {
            this.scrubCell(coords.row, coords.col);
            affectedCells.add(`${coords.row},${coords.col}`);
          }
        }
        
        if (coords.row != row || coords.col != col) {
          this.grid[coords.row][coords.col]["idPiece"] = null;
          this.grid[coords.row][coords.col]["origineX"] = col;
          this.grid[coords.row][coords.col]["origineY"] = row;
          this.grid[coords.row][coords.col]["sens"] = null;
        }
      }
      
      this.grid[row][col]["idPiece"] = idPiece;
      this.grid[row][col]["origineX"] = null;
      this.grid[row][col]["origineY"] = null;
      this.grid[row][col]["sens"] = rotation;
      
      await this.redrawAffectedCells(affectedCells);
    },

    async redrawAffectedCells(affectedCells) {
      const processedPieces = new Set();
      
      for (const cellKey of affectedCells) {
        const [row, col] = cellKey.split(',').map(Number);
        
        const { row: principalRow, col: principalCol } = this.getPrincipalCell(row, col);
        const pieceKey = `${principalRow},${principalCol}`;
        
        if (!processedPieces.has(pieceKey)) {
          processedPieces.add(pieceKey);
          await this.redrawSinglePiece(principalRow, principalCol);
        }
      }
    },
    
    fill(row, col, targetPiece, replacementPiece, sens) {
      let espacePosable = [];
      let pileFill = [[row, col]];
      let visited = [];
      
      while (pileFill.length > 0) {
        const [rowActuel, colActuel] = pileFill.pop();
        
        if (this.isVisited(visited, rowActuel, colActuel)) continue;
        visited.push([rowActuel, colActuel]);
        
        if (!this.isValidCell(rowActuel, colActuel)) continue;
        
        let idPiece = this.grid[rowActuel][colActuel]["idPiece"];
        
        if (idPiece != targetPiece || targetPiece == null) {
          const origineX = this.grid[rowActuel][colActuel]["origineX"];
          const origineY = this.grid[rowActuel][colActuel]["origineY"];
          
          if (origineX != null && origineY != null) {
            idPiece = this.grid[origineY][origineX]["idPiece"];
          }
        }
        
        if (idPiece != targetPiece) continue;
        
        espacePosable.push([rowActuel, colActuel]);
        
        pileFill.push([rowActuel + 1, colActuel]);
        pileFill.push([rowActuel - 1, colActuel]);
        pileFill.push([rowActuel, colActuel + 1]);
        pileFill.push([rowActuel, colActuel - 1]);
      }
      
      pileFill = [[row, col]];
      
      while (pileFill.length > 0) {
        const [rowActuel, colActuel] = pileFill.pop();
        
        const { coordPiece, historyStrings, isPosable } = 
          this.checkPiecePlacement(rowActuel, colActuel, replacementPiece, sens, espacePosable, targetPiece);
        
        if (isPosable) {
          this.idPieceString += "-" + historyStrings.idPieceString;
          this.colsString += "-" + historyStrings.colsString;
          this.rowsString += "-" + historyStrings.rowsString;
          this.sensString += "-" + historyStrings.sensString;
          
          this.paintCell(rowActuel, colActuel, replacementPiece, sens);
          
          espacePosable = espacePosable.filter(item => {
            return !coordPiece.some(coord =>
              Number(coord[0]) === Number(item[0]) &&
              Number(coord[1]) === Number(item[1])
            );
          });
          
          const { tailWidht, tailHight } = this.getPieceDimensions(replacementPiece, sens);
          
          pileFill.push([rowActuel + tailHight, colActuel]);
          pileFill.push([rowActuel - tailHight, colActuel]);
          pileFill.push([rowActuel, colActuel + tailWidht]);
          pileFill.push([rowActuel, colActuel - tailWidht]);
        }
      }
    },
    
    isVisited(visited, row, col) {
      return visited.some(item =>
        Number(item[0]) === Number(row) &&
        Number(item[1]) === Number(col)
      );
    },
    
    checkPiecePlacement(rowActuel, colActuel, replacementPiece, sens, espacePosable, targetPiece) {
      const coordPiece = [];
      let isPosable = true;
      const espaceOccupe = this.listePiece[replacementPiece]['shema']['espaceOccupe'];
      
      let idPieceString = "";
      let colsString = "";
      let rowsString = "";
      let sensString = "";
      
      for (let i = 0; i < espaceOccupe.length; i++) {
        const espaceParse = espaceOccupe[i].split('-').filter(part => part !== '').map(Number);
        let espaceHightAbsolue = espaceParse[0];
        let espaceWidthAbsolue = espaceParse[1];
        
        const { espaceWidth, espaceHight } = 
          this.getRotatedDimensions(espaceWidthAbsolue, espaceHightAbsolue, sens);
        
        const existe = espacePosable.some(item =>
          Number(item[0]) === Number(rowActuel + espaceHight) &&
          Number(item[1]) === Number(colActuel + espaceWidth)
        );
        
        if (!existe) {
          isPosable = false;
          break;
        }
        
        const cellData = this.getCellHistoryData(rowActuel, colActuel, espaceHight, espaceWidth, targetPiece);
        idPieceString += "-" + cellData.idPiece;
        colsString += "-" + cellData.col;
        rowsString += "-" + cellData.row;
        sensString += "-" + cellData.sens;
        
        coordPiece.push([rowActuel + espaceHight, colActuel + espaceWidth]);
      }
      
      return {
        coordPiece,
        historyStrings: { idPieceString, colsString, rowsString, sensString },
        isPosable
      };
    },
    
    getRotatedDimensions(width, height, sens) {
      let espaceWidth, espaceHight;
      
      switch (sens) {
        case 0:
          espaceWidth = 1 * width - 1;
          espaceHight = 1 * height - 1;
          break;
        case 90:
          espaceWidth = 1 * height - 1;
          espaceHight = 1 * width - 1;
          break;
        case 180:
          espaceWidth = -1 * width + 1;
          espaceHight = 1 * height - 1;
          break;
        case 270:
          espaceWidth = 1 * height - 1;
          espaceHight = -1 * width + 1;
          break;
        default:
          espaceWidth = 0;
          espaceHight = 0;
      }
      
      return { espaceWidth, espaceHight };
    },
    
    getCellHistoryData(row, col, espaceHight, espaceWidth, targetPiece) {
      const targetRow = row + espaceHight;
      const targetCol = col + espaceWidth;
      
      if (this.grid[targetRow][targetCol]["idPiece"] != null) {
        return {
          idPiece: this.grid[targetRow][targetCol]["idPiece"],
          col: targetCol,
          row: targetRow,
          sens: this.grid[targetRow][targetCol]["sens"]
        };
      } else if (this.grid[targetRow][targetCol]["origineX"] != null) {
        const origineX = this.grid[targetRow][targetCol]["origineX"];
        const origineY = this.grid[targetRow][targetCol]["origineY"];
        return {
          idPiece: this.grid[origineY][origineX]["idPiece"],
          col: origineX,
          row: origineY,
          sens: this.grid[origineY][origineX]["sens"]
        };
      } else if (targetPiece == null) {
        return {
          idPiece: this.grid[targetRow][targetCol]["idPiece"],
          col: targetCol,
          row: targetRow,
          sens: this.grid[targetRow][targetCol]["sens"]
        };
      }
      
      return { idPiece: null, col: targetCol, row: targetRow, sens: null };
    },
    
    getPieceDimensions(replacementPiece, sens) {
      const tailHightAbsolue = 1 * this.listePiece[replacementPiece]['shema']['taileY'];
      const tailWidhtAbsolue = 1 * this.listePiece[replacementPiece]['shema']['taileX'];
      
      let tailHight, tailWidht;
      
      if (sens == 0 || sens == 180) {
        tailWidht = 1 * tailWidhtAbsolue;
        tailHight = 1 * tailHightAbsolue;
      } else if (sens == 90 || sens == 270) {
        tailWidht = 1 * tailHightAbsolue;
        tailHight = 1 * tailWidhtAbsolue;
      }
      
      return { tailWidht, tailHight };
    },
    
    // ============================================
    // ZOOM
    // ============================================
    
    async zoomIn() {
      if (this.zoom < ZOOM_MAX) {
        this.zoom += ZOOM_STEP;
        console.log("zoom : ",this.zoom);
        await this.checkAndRedrawZoom()
      }
    },
    
    async zoomOut() {
      if (this.zoom > this.zoomMin) {
        this.zoom -= ZOOM_STEP;
        console.log("zoom : ",this.zoom);
        await this.checkAndRedrawZoom()
      }
    },

    async checkAndRedrawZoom() {
      if (this.isDrawingZoom) return;

      if (this.zoom != this.currentDrawnZoom) {
        await this.updateCanvasWithZoom();
      }
    },

    async updateCanvasWithZoom() {
      this.isDrawingZoom = true;
      const canvas = this.$refs.canvas;
      const overlay = this.$refs.overlayCanvas;
      const container = this.$refs.canvasContainer;

      if (!canvas || !overlay || !container) {
        this.isDrawingZoom = false;
        return;
      }
      
      const navbarHeight = document.querySelector('.navbar')?.offsetHeight || 0;
      const viewXHeight = 20;
      const windowHeight = window.innerHeight;
      const newCanvasHeight = windowHeight - navbarHeight - viewXHeight - 60;

      // Calculer la largeur disponible
      let availableWidth;
      if (window.innerWidth < 768) {
        availableWidth = window.innerWidth - 40;
      } else {
        availableWidth = container.clientWidth - 40;
      }

      const newWidth = Math.max(300, availableWidth);
      const newHeight = Math.max(300, newCanvasHeight);
      const newCellSize = BASE_CELL_SIZE * this.zoom;
      
      canvas.width = overlay.width = newWidth;
      canvas.height = overlay.height = newHeight;
      
      this.offscreenCanvas.width = newWidth;
      this.offscreenCanvas.height = newHeight;
      
      this.canvasHeight = newCanvasHeight;
      this.cellSize = newCellSize;
      
      if (this.$refs.viewY) {
        this.$refs.viewY.style.height = `${newHeight}px`;
      }

      console.log('Canvas updated with zoom:', { width: newWidth, height: newHeight, cellSize: newCellSize });
      
      this.isDirty = true;
      await this.drawFullGrid();
      this.copyBufferToCanvas();
      this.drawGhostPiece();
      this.currentDrawnZoom = this.zoom;
      this.isDrawingZoom = false;
      if (this.zoom != this.currentDrawnZoom) {
        await this.checkAndRedrawZoom();
      }
    },

    createImagePromisesWithCellSize(basePath, cellSize) {
      return this.createImagePromises(basePath, cellSize);
    },
    
    // ============================================
    // SAUVEGARDE
    // ============================================
    
    saveToLocalStorage() {
      localStorage.setItem('grid' + this.mosaicId, JSON.stringify(this.grid));
      localStorage.setItem('history' + this.mosaicId, JSON.stringify(this.history));
    },
    
    async saveMosaic() {
      const token = localStorage.getItem('token');
      
      const gridData = this.grid.map(row =>
        row.map(cell => ({
          idPiece: cell.idPiece,
          origineY: cell.origineY,
          origineX: cell.origineX,
          sens: cell.sens
        }))
      );
      
      const payload = { grid: gridData };
      
      try {
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        await axios.post(
          `${API_URL}/api/mosaic/save/${this.mosaicId}`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        );
      } catch (error) {
        this.handleError('Erreur lors de la sauvegarde', error);
      }
    },
    
    // ============================================
    // UTILITAIRES
    // ============================================
    
    openProgressBar() {
      this.modalInstance.show();
    },
    
    closeProgressBar() {
      this.modalInstance.hide();
    },
    
    updateNavbarHeight() {
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        const navbarHeight = navbar.offsetHeight;
        document.documentElement.style.setProperty('--hauteurNavbar', `${navbarHeight}px`);
      }
    },
    
    handleError(message, error) {
      console.error(message, error);
    },

    updateTool(tool) {
      this.lasteTool = this.currentTool
      this.currentTool = tool.value;
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

/* SIDEBAR TOGGLE BUTTON (MOBILE) */
.sidebar-toggle {
  display: none;
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1050;
  background-color: #4dc9ff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 1.5rem;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0,0,0,0.3);
  transition: all 0.3s ease;
  align-items: center;
  justify-content: center;
}

.sidebar-toggle:active {
  transform: scale(0.95);
}

.sidebar-toggle:hover {
  background-color: #3ab8e8;
  box-shadow: 0 6px 20px rgba(0,0,0,0.4);
}

.sidebar-toggle span {
  line-height: 1;
}

.sidebar-toggle.toggle-active {
  left: 300px;
  background-color: #ff4d4d;
}

/* SIDEBAR */
.sidebar {
  transition: transform 0.3s ease;
}

.sidebar-content {
  width: 100%;
}

/* CANVAS CONTAINER */
.canvas-container {
  transition: margin-left 0.3s ease;
  padding: 20px;
  overflow: hidden;
}

.canvas-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
}

.canvas-with-slider {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.canvas-stack {
  position: relative;
  display: inline-block;
}

.main-canvas {
  border: 1px solid #000;
  display: block;
}

.overlay-canvas {
  position: absolute;
  top: 0;
  left: 0;
  cursor: crosshair;
  pointer-events: all;
}

.viewX {
  width: 100%;
}

/* BUTTONS */
.btn-save {
  width: 100%;
  background-color: white;
  color: #4dc9ff;
  border: 2px solid white;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s;
}

.btn-save:hover {
  background-color: #f0f0f0;
  transform: translateY(-2px);
}

/* SLIDERS */
.vertical-slider {
  -webkit-appearance: none;
  appearance: none;
  width: 10px;
  height: 100%;
  background: #e9ecef;
  cursor: pointer;
  margin-left: 10px;
  writing-mode: vertical-lr;
  border-radius: 10px;
}

.vertical-slider::-webkit-slider-runnable-track {
  width: 15px;
  background: #e9ecef;
  border-radius: 50%;
}

.vertical-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  background: #007bff;
  border-radius: 50%;
  cursor: pointer;
}

.vertical-slider::-moz-range-track {
  width: 10px;
  background: #e9ecef;
  border-radius: 10px;
}

.vertical-slider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  background: #007bff;
  border-radius: 50%;
  cursor: pointer;
}

.vertical-slider::-ms-track {
  width: 10px;
  background: #e9ecef;
  border-radius: 10px;
}

.vertical-slider::-ms-thumb {
  width: 15px;
  height: 15px;
  background: #007bff;
  border-radius: 50%;
  cursor: pointer;
}

/* CANVAS */
canvas {
  cursor: crosshair;
  box-sizing: border-box;
}

/* TOOL BUTTONS */
.tool-button {
  background-color: #4dc9ff;
  color: white;
  border: 1px solid white;
  padding: 6px 12px;
  margin-bottom: 5px;
  cursor: pointer;
  width: 100%;
  text-align: left;
}

.tool-button.active {
  background-color: white;
  color: #4dc9ff;
}

/* COLOR BUTTONS */
.color-button {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

/* PIECES SCROLL */
.pieces-scroll {
  scrollbar-width: thin;
  scrollbar-color: #007bff #e9ecef;
}

.pieces-scroll::-webkit-scrollbar {
  width: 10px;
}

.pieces-scroll::-webkit-scrollbar-track {
  background: #e9ecef;
  border-radius: 10px;
}

.pieces-scroll::-webkit-scrollbar-thumb {
  background-color: #e9ecef;
  border-radius: 50px;
  border: 2px solid #0056b3;
}

.pieces-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #e9ecef;
}

/* RESPONSIVE - TABLET */
@media (max-width: 992px) {
  .sidebar {
    width: 200px !important;
    min-width: 200px !important;
  }
}

/* RESPONSIVE - MOBILE */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
  }

  /* Sidebar Mobile */
  .sidebar {
    position: fixed !important;
    top: var(--hauteurNavbar, 0px);
    left: 0;
    width: 280px !important;
    min-width: 280px !important;
    height: calc(100vh - var(--hauteurNavbar, 0px));
    z-index: 1040;
    transform: translateX(-100%);
    box-shadow: 2px 0 10px rgba(0,0,0,0.2);
  }

  .sidebar-open {
    transform: translateX(0) !important;
  }

  .sidebar-toggle {
    display: flex !important;
  }

  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1030;
  }

  /* Canvas Container Mobile */
  .canvas-container {
    width: 100% !important;
    flex: 1 !important;
    padding: 15px 10px !important;
    margin: 0 !important;
  }

  .canvas-wrapper {
    width: 100%;
    max-width: 100%;
  }

  .canvas-stack {
    max-width: calc(100vw - 40px);
  }

  .main-canvas,
  .overlay-canvas {
    max-width: 100%;
  }

  .tool-button {
    font-size: 0.9rem;
    padding: 8px 10px;
  }

  .pieces-scroll {
    max-height: 25vh !important;
  }
}

/* RESPONSIVE - SMALL MOBILE */
@media (max-width: 480px) {
  .sidebar {
    width: 100% !important;
    min-width: 100% !important;
  }

  .sidebar-toggle {
    width: 55px;
    height: 55px;
    font-size: 1.4rem;
    bottom: 15px;
    left: 15px;
  }

  .sidebar-toggle.toggle-active {
    left: calc(100% - 70px);
  }

  .canvas-container {
    padding: 10px 5px !important;
  }

  .canvas-stack {
    max-width: calc(100vw - 20px);
  }

  .btn-save {
    padding: 8px;
    font-size: 0.9rem;
  }
}
</style>